module.exports = __webpack_public_path__ + "media/images/client-18-9302d27fa06036af6d74e9186c4f2fd0.png";